import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonCol, IonRow} from '@ionic/angular/standalone';

@Component({
    selector: 'app-responsive-container',
    templateUrl: './responsive-container.component.html',
    styleUrls: ['./responsive-container.component.scss'],
  imports: [CommonModule, IonCol, IonRow]
})
export class ResponsiveContainerComponent {

  @Input()
  public large: boolean;

  public constructor() {
  }

}
